import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => {
    const context = useContext(CartContext);
    if (!context) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
};

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState(() => {
        const saved = localStorage.getItem('hypnosis-cart');
        return saved ? JSON.parse(saved) : [];
    });

    useEffect(() => {
        localStorage.setItem('hypnosis-cart', JSON.stringify(cartItems));
    }, [cartItems]);

    const addToCart = (recording) => {
        setCartItems(prev => {
            const exists = prev.find(item => item.id === recording.id);
            if (exists) return prev;
            return [...prev, recording];
        });
    };

    const removeFromCart = (recordingId) => {
        setCartItems(prev => prev.filter(item => item.id !== recordingId));
    };

    const clearCart = () => {
        setCartItems([]);
    };

    const isInCart = (recordingId) => {
        return cartItems.some(item => item.id === recordingId);
    };

    const getTotal = () => {
        return cartItems.reduce((sum, item) => sum + item.price, 0);
    };

    const getCount = () => {
        return cartItems.length;
    };

    return (
        <CartContext.Provider value={{
            cartItems,
            addToCart,
            removeFromCart,
            clearCart,
            isInCart,
            getTotal,
            getCount
        }}>
            {children}
        </CartContext.Provider>
    );
};
